import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

import { DOCUMENT_TYPES } from "./defines/documentTypes";
import { ROUTES } from "./defines/routes";

export function usePassengerDetailsAnalytics(passenger) {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);

  useEffect(() => {
    if (pathname === ROUTES.passengerDetails) {
      const { requirements: { missing = [], swiped = [], on_file = [] } = {}, id } =
        passenger ?? {};
      const documentsToScan = [...on_file, ...swiped];
      const residentCardRequired = documentsToScan.includes(DOCUMENT_TYPES.PERMANENT_RESIDENT_CARD);
      const passportRequired = documentsToScan.includes(DOCUMENT_TYPES.PASSPORT);

      setMktgPageData(
        {
          document_complete: documentScanComplete(on_file, missing) ? "1" : "0",
          pax_number: `${id}`,
          ...(passportRequired
            ? {
                passport_scan_complete: swiped.includes(DOCUMENT_TYPES.PASSPORT) ? "1" : "0",
              }
            : {}),
          ...(residentCardRequired
            ? {
                resident_card_scan_complete: swiped.includes(DOCUMENT_TYPES.PERMANENT_RESIDENT_CARD)
                  ? "1"
                  : "0",
              }
            : {}),
        },
        "passengerDetails"
      );
    }
  }, [pathname, passenger]);

  function documentScanComplete(onFile, missing) {
    return missing.length === 0 && onFile.every((document) => !DOCUMENT_TYPES[document]);
  }
}
